document.onkeydown = function (e) {
    let classRadio;
    if (e.key === 'Enter' && document.activeElement.previousSibling !== null) {
        const labelSelect = document.activeElement.previousSibling.parentNode;
        classRadio = labelSelect.className;
        if (classRadio.includes("custom-radio")) {
            labelSelect.firstChild.checked = true;
        }
    }
}

